export default "__VITE_ASSET__DBEdRE8u__"